// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  userId: __t.string().name("user_id"),
  projectId: __t.string().name("project_id"),
  active: __t.bool(),
  joinedAt: __t.timestamp().name("joined_at"),
  leftAt: __t.option(__t.timestamp()).name("left_at"),
});
